export const COUNTRIES = [
    {
        id: 1,
        code: "CO",
        name: "Colombia",
        phoneCode: "+57",
        flag: "https://static.platzi.com/media/flags/CO.png"
    },
    {
        id: 2,
        code: "MX",
        name: "Mexico",
        phoneCode: "+52",
        flag: "https://static.platzi.com/media/flags/MX.png"
    },
    {
        id: 3,
        code: "US",
        name: "Estados unidos",
        phoneCode: "+1",
        flag: "https://static.platzi.com/media/flags/US.png"
    },
    {
        id: 4,
        code: "PE",
        name: "Perú",
        phoneCode: "+51",
        flag: "https://static.platzi.com/media/flags/PE.png"
    },
    {
        id: 5,
        code: "CL",
        name: "Chile",
        phoneCode: "+56",
        flag: "https://static.platzi.com/media/flags/CL.png"
    },
    {
        id: 6,
        code: "AF",
        name: "Afghanistan",
        phoneCode: "+93",
        flag: "https://static.platzi.com/media/flags/AF.png"
    },
    {
        id: 8,
        code: "AL",
        name: "Albania",
        phoneCode: "+355",
        flag: "https://static.platzi.com/media/flags/AL.png"
    },
    {
        id: 9,
        code: "DZ",
        name: "Algeria",
        phoneCode: "+213",
        flag: "https://static.platzi.com/media/flags/DZ.png"
    },
    {
        id: 10,
        code: "AS",
        name: "American Samoa",
        phoneCode: "+1-684",
        flag: "https://static.platzi.com/media/flags/AS.png"
    },
    {
        id: 11,
        code: "AD",
        name: "Andorra",
        phoneCode: "+376",
        flag: "https://static.platzi.com/media/flags/AD.png"
    },
    {
        id: 12,
        code: "AO",
        name: "Angola",
        phoneCode: "+244",
        flag: "https://static.platzi.com/media/flags/AO.png"
    },
    {
        id: 13,
        code: "AI",
        name: "Anguilla",
        phoneCode: "+1-264",
        flag: "https://static.platzi.com/media/flags/AI.png"
    },
    {
        id: 14,
        code: "AG",
        name: "Antigua and Barbuda",
        phoneCode: "+1-268",
        flag: "https://static.platzi.com/media/flags/AG.png"
    },
    {
        id: 15,
        code: "AR",
        name: "Argentina",
        phoneCode: "+54",
        flag: "https://static.platzi.com/media/flags/AR.png"
    },
    {
        id: 16,
        code: "AM",
        name: "Armenia",
        phoneCode: "+374",
        flag: "https://static.platzi.com/media/flags/AM.png"
    },
    {
        id: 17,
        code: "AW",
        name: "Aruba",
        phoneCode: "+297",
        flag: "https://static.platzi.com/media/flags/AW.png"
    },
    {
        id: 19,
        code: "AT",
        name: "Austria",
        phoneCode: "+43",
        flag: "https://static.platzi.com/media/flags/AT.png"
    },
    {
        id: 20,
        code: "AZ",
        name: "Azerbaijan",
        phoneCode: "+994",
        flag: "https://static.platzi.com/media/flags/AZ.png"
    },
    {
        id: 21,
        code: "BS",
        name: "Bahamas",
        phoneCode: "+1-242",
        flag: "https://static.platzi.com/media/flags/BS.png"
    },
    {
        id: 22,
        code: "BH",
        name: "Bahrain",
        phoneCode: "+973",
        flag: "https://static.platzi.com/media/flags/BH.png"
    },
    {
        id: 23,
        code: "BD",
        name: "Bangladesh",
        phoneCode: "+880",
        flag: "https://static.platzi.com/media/flags/BD.png"
    },
    {
        id: 24,
        code: "BB",
        name: "Barbados",
        phoneCode: "+1-246",
        flag: "https://static.platzi.com/media/flags/BB.png"
    },
    {
        id: 25,
        code: "BY",
        name: "Belarus",
        phoneCode: "+375",
        flag: "https://static.platzi.com/media/flags/BY.png"
    },
    {
        id: 34,
        code: "BR",
        name: "Brazil",
        phoneCode: "+55",
        flag: "https://static.platzi.com/media/flags/BR.png"
    },
    {
        id: 27,
        code: "BZ",
        name: "Belize",
        phoneCode: "+501",
        flag: "https://static.platzi.com/media/flags/BZ.png"
    },
    {
        id: 28,
        code: "BJ",
        name: "Benin",
        phoneCode: "+229",
        flag: "https://static.platzi.com/media/flags/BJ.png"
    },
    {
        id: 29,
        code: "BM",
        name: "Bermuda",
        phoneCode: "+1-441",
        flag: "https://static.platzi.com/media/flags/BM.png"
    },
    {
        id: 30,
        code: "BT",
        name: "Bhutan",
        phoneCode: "+975",
        flag: "https://static.platzi.com/media/flags/BT.png"
    },
    {
        id: 31,
        code: "BO",
        name: "Bolivia",
        phoneCode: "+591",
        flag: "https://static.platzi.com/media/flags/BO.png"
    },
    {
        id: 32,
        code: "BA",
        name: "Bosnia and Herzegovina",
        phoneCode: "+387",
        flag: "https://static.platzi.com/media/flags/BA.png"
    },
    {
        id: 33,
        code: "BW",
        name: "Botswana",
        phoneCode: "+267",
        flag: "https://static.platzi.com/media/flags/BW.png"
    },
    {
        id: 35,
        code: "IO",
        name: "British Indian Ocean Territory",
        phoneCode: "+246",
        flag: "https://static.platzi.com/media/flags/IO.png"
    },
    {
        id: 36,
        code: "VG",
        name: "British Virgin Islands",
        phoneCode: "+1-284",
        flag: "https://static.platzi.com/media/flags/VG.png"
    },
    {
        id: 37,
        code: "BN",
        name: "Brunei",
        phoneCode: "+673",
        flag: "https://static.platzi.com/media/flags/BN.png"
    },
    {
        id: 38,
        code: "BG",
        name: "Bulgaria",
        phoneCode: "+359",
        flag: "https://static.platzi.com/media/flags/BG.png"
    },
    {
        id: 39,
        code: "BF",
        name: "Burkina Faso",
        phoneCode: "+226",
        flag: "https://static.platzi.com/media/flags/BF.png"
    },
    {
        id: 40,
        code: "BI",
        name: "Burundi",
        phoneCode: "+257",
        flag: "https://static.platzi.com/media/flags/BI.png"
    },
    {
        id: 41,
        code: "KH",
        name: "Cambodia",
        phoneCode: "+855",
        flag: "https://static.platzi.com/media/flags/KH.png"
    },
    {
        id: 42,
        code: "CM",
        name: "Cameroon",
        phoneCode: "+237",
        flag: "https://static.platzi.com/media/flags/CM.png"
    },
    {
        id: 43,
        code: "CA",
        name: "Canada",
        phoneCode: "+1",
        flag: "https://static.platzi.com/media/flags/CA.png"
    },
    {
        id: 44,
        code: "CV",
        name: "Cape Verde",
        phoneCode: "+238",
        flag: "https://static.platzi.com/media/flags/CV.png"
    },
    {
        id: 45,
        code: "KY",
        name: "Cayman Islands",
        phoneCode: "+1-345",
        flag: "https://static.platzi.com/media/flags/KY.png"
    },
    {
        id: 46,
        code: "CF",
        name: "Central African Republic",
        phoneCode: "+236",
        flag: "https://static.platzi.com/media/flags/CF.png"
    },
    {
        id: 47,
        code: "TD",
        name: "Chad",
        phoneCode: "+235",
        flag: "https://static.platzi.com/media/flags/TD.png"
    },
    {
        id: 48,
        code: "CN",
        name: "China",
        phoneCode: "+86",
        flag: "https://static.platzi.com/media/flags/CN.png"
    },
    {
        id: 49,
        code: "CX",
        name: "Christmas Island",
        phoneCode: "+61",
        flag: "https://static.platzi.com/media/flags/CX.png"
    },
    {
        id: 50,
        code: "CC",
        name: "Cocos Islands",
        phoneCode: "+61",
        flag: "https://static.platzi.com/media/flags/CC.png"
    },
    {
        id: 51,
        code: "KM",
        name: "Comoros",
        phoneCode: "+269",
        flag: "https://static.platzi.com/media/flags/KM.png"
    },
    {
        id: 52,
        code: "CK",
        name: "Cook Islands",
        phoneCode: "+682",
        flag: "https://static.platzi.com/media/flags/CK.png"
    },
    {
        id: 53,
        code: "CR",
        name: "Costa Rica",
        phoneCode: "+506",
        flag: "https://static.platzi.com/media/flags/CR.png"
    },
    {
        id: 54,
        code: "HR",
        name: "Croatia",
        phoneCode: "+385",
        flag: "https://static.platzi.com/media/flags/HR.png"
    },
    {
        id: 56,
        code: "CY",
        name: "Cyprus",
        phoneCode: "+357",
        flag: "https://static.platzi.com/media/flags/CY.png"
    },
    {
        id: 57,
        code: "CZ",
        name: "Czech Republic",
        phoneCode: "+420",
        flag: "https://static.platzi.com/media/flags/CZ.png"
    },
    {
        id: 58,
        code: "CD",
        name: "Democratic Republic of the Congo",
        phoneCode: "+243",
        flag: "https://static.platzi.com/media/flags/CD.png"
    },
    {
        id: 59,
        code: "DK",
        name: "Denmark",
        phoneCode: "+45",
        flag: "https://static.platzi.com/media/flags/DK.png"
    },
    {
        id: 60,
        code: "DJ",
        name: "Djibouti",
        phoneCode: "+253",
        flag: "https://static.platzi.com/media/flags/DJ.png"
    },
    {
        id: 61,
        code: "DM",
        name: "Dominica",
        phoneCode: "+1-767",
        flag: "https://static.platzi.com/media/flags/DM.png"
    },
    {
        id: 178,
        code: "RU",
        name: "Russia",
        phoneCode: "+7",
        flag: "https://static.platzi.com/media/flags/R.png"
    },
    {
        id: 65,
        code: "TL",
        name: "East Timor",
        phoneCode: "+670",
        flag: "https://static.platzi.com/media/flags/TL.png"
    },
    {
        id: 66,
        code: "EC",
        name: "Ecuador",
        phoneCode: "+593",
        flag: "https://static.platzi.com/media/flags/ecuador.png"
    },
    {
        id: 67,
        code: "EG",
        name: "Egypt",
        phoneCode: "+20",
        flag: "https://static.platzi.com/media/flags/EG.png"
    },
    {
        id: 68,
        code: "SV",
        name: "El Salvador",
        phoneCode: "+503",
        flag: "https://static.platzi.com/media/flags/SV.png"
    },
    {
        id: 69,
        code: "GQ",
        name: "Equatorial Guinea",
        phoneCode: "+240",
        flag: "https://static.platzi.com/media/flags/GQ.png"
    },
    {
        id: 70,
        code: "ER",
        name: "Eritrea",
        phoneCode: "+291",
        flag: "https://static.platzi.com/media/flags/ER.png"
    },
    {
        id: 71,
        code: "EE",
        name: "Estonia",
        phoneCode: "+372",
        flag: "https://static.platzi.com/media/flags/EE.png"
    },
    {
        id: 72,
        code: "ET",
        name: "Ethiopia",
        phoneCode: "+251",
        flag: "https://static.platzi.com/media/flags/ET.png"
    },
    {
        id: 73,
        code: "FK",
        name: "Falkland Islands",
        phoneCode: "+500",
        flag: "https://static.platzi.com/media/flags/FK.png"
    },
    {
        id: 74,
        code: "FO",
        name: "Faroe Islands",
        phoneCode: "+298",
        flag: "https://static.platzi.com/media/flags/FO.png"
    },
    {
        id: 75,
        code: "FJ",
        name: "Fiji",
        phoneCode: "+679",
        flag: "https://static.platzi.com/media/flags/FJ.png"
    },
    {
        id: 76,
        code: "FI",
        name: "Finland",
        phoneCode: "+358",
        flag: "https://static.platzi.com/media/flags/FI.png"
    },
    {
        id: 18,
        code: "AU",
        name: "Australia",
        phoneCode: "+61",
        flag: "https://static.platzi.com/media/flags/A.png"
    },
    {
        id: 78,
        code: "PF",
        name: "French Polynesia",
        phoneCode: "+689",
        flag: "https://static.platzi.com/media/flags/PF.png"
    },
    {
        id: 79,
        code: "GA",
        name: "Gabon",
        phoneCode: "+241",
        flag: "https://static.platzi.com/media/flags/GA.png"
    },
    {
        id: 80,
        code: "GM",
        name: "Gambia",
        phoneCode: "+220",
        flag: "https://static.platzi.com/media/flags/GM.png"
    },
    {
        id: 81,
        code: "GE",
        name: "Georgia",
        phoneCode: "+995",
        flag: "https://static.platzi.com/media/flags/GE.png"
    },
    {
        id: 83,
        code: "GH",
        name: "Ghana",
        phoneCode: "+233",
        flag: "https://static.platzi.com/media/flags/GH.png"
    },
    {
        id: 84,
        code: "GI",
        name: "Gibraltar",
        phoneCode: "+350",
        flag: "https://static.platzi.com/media/flags/GI.png"
    },
    {
        id: 85,
        code: "GR",
        name: "Greece",
        phoneCode: "+30",
        flag: "https://static.platzi.com/media/flags/GR.png"
    },
    {
        id: 86,
        code: "GL",
        name: "Greenland",
        phoneCode: "+299",
        flag: "https://static.platzi.com/media/flags/GL.png"
    },
    {
        id: 87,
        code: "GD",
        name: "Grenada",
        phoneCode: "+1-473",
        flag: "https://static.platzi.com/media/flags/GD.png"
    },
    {
        id: 89,
        code: "GT",
        name: "Guatemala",
        phoneCode: "+502",
        flag: "https://static.platzi.com/media/flags/GT.png"
    },
    {
        id: 90,
        code: "GG",
        name: "Guernsey",
        phoneCode: "+44-1481",
        flag: "https://static.platzi.com/media/flags/GG.png"
    },
    {
        id: 91,
        code: "GN",
        name: "Guinea",
        phoneCode: "+224",
        flag: "https://static.platzi.com/media/flags/GN.png"
    },
    {
        id: 92,
        code: "GW",
        name: "Guinea-Bissa",
        phoneCode: "+245",
        flag: "https://static.platzi.com/media/flags/GW.png"
    },
    {
        id: 93,
        code: "GY",
        name: "Guyana",
        phoneCode: "+592",
        flag: "https://static.platzi.com/media/flags/GY.png"
    },
    {
        id: 94,
        code: "HT",
        name: "Haiti",
        phoneCode: "+509",
        flag: "https://static.platzi.com/media/flags/HT.png"
    },
    {
        id: 95,
        code: "HN",
        name: "Honduras",
        phoneCode: "+504",
        flag: "https://static.platzi.com/media/flags/HN.png"
    },
    {
        id: 96,
        code: "HK",
        name: "Hong Kong",
        phoneCode: "+852",
        flag: "https://static.platzi.com/media/flags/HK.png"
    },
    {
        id: 98,
        code: "IS",
        name: "Iceland",
        phoneCode: "+354",
        flag: "https://static.platzi.com/media/flags/IS.png"
    },
    {
        id: 99,
        code: "IN",
        name: "India",
        phoneCode: "+91",
        flag: "https://static.platzi.com/media/flags/IN.png"
    },
    {
        id: 100,
        code: "ID",
        name: "Indonesia",
        phoneCode: "+62",
        flag: "https://static.platzi.com/media/flags/ID.png"
    },
    {
        id: 101,
        code: "IR",
        name: "Iran",
        phoneCode: "+98",
        flag: "https://static.platzi.com/media/flags/IR.png"
    },
    {
        id: 102,
        code: "IQ",
        name: "Iraq",
        phoneCode: "+964",
        flag: "https://static.platzi.com/media/flags/IQ.png"
    },
    {
        id: 103,
        code: "IE",
        name: "Ireland",
        phoneCode: "+353",
        flag: "https://static.platzi.com/media/flags/IE.png"
    },
    {
        id: 104,
        code: "IM",
        name: "Isle of Man",
        phoneCode: "+44-1624",
        flag: "https://static.platzi.com/media/flags/IM.png"
    },
    {
        id: 105,
        code: "IL",
        name: "Israel",
        phoneCode: "+972",
        flag: "https://static.platzi.com/media/flags/IL.png"
    },
    {
        id: 107,
        code: "CI",
        name: "Ivory Coast",
        phoneCode: "+225",
        flag: "https://static.platzi.com/media/flags/CI.png"
    },
    {
        id: 106,
        code: "IT",
        name: "Italy",
        phoneCode: "+39",
        flag: "https://static.platzi.com/media/flags/IT.png"
    },
    {
        id: 77,
        code: "FR",
        name: "France",
        phoneCode: "+33",
        flag: "https://static.platzi.com/media/flags/FR.png"
    },
    {
        id: 26,
        code: "BE",
        name: "Belgium",
        phoneCode: "+32",
        flag: "https://static.platzi.com/media/flags/BE.png"
    },
    {
        id: 108,
        code: "JM",
        name: "Jamaica",
        phoneCode: "+1-876",
        flag: "https://static.platzi.com/media/flags/JM.png"
    },
    {
        id: 109,
        code: "JP",
        name: "Japan",
        phoneCode: "+81",
        flag: "https://static.platzi.com/media/flags/JP.png"
    },
    {
        id: 110,
        code: "JE",
        name: "Jersey",
        phoneCode: "+44-1534",
        flag: "https://static.platzi.com/media/flags/JE.png"
    },
    {
        id: 111,
        code: "JO",
        name: "Jordan",
        phoneCode: "+962",
        flag: "https://static.platzi.com/media/flags/JO.png"
    },
    {
        id: 112,
        code: "KZ",
        name: "Kazakhstan",
        phoneCode: "+7",
        flag: "https://static.platzi.com/media/flags/KZ.png"
    },
    {
        id: 113,
        code: "KE",
        name: "Kenya",
        phoneCode: "+254",
        flag: "https://static.platzi.com/media/flags/KE.png"
    },
    {
        id: 114,
        code: "KI",
        name: "Kiribati",
        phoneCode: "+686",
        flag: "https://static.platzi.com/media/flags/KI.png"
    },
    {
        id: 115,
        code: "KW",
        name: "Kuwait",
        phoneCode: "+965",
        flag: "https://static.platzi.com/media/flags/KW.png"
    },
    {
        id: 116,
        code: "KG",
        name: "Kyrgyzstan",
        phoneCode: "+996",
        flag: "https://static.platzi.com/media/flags/KG.png"
    },
    {
        id: 117,
        code: "LA",
        name: "Laos",
        phoneCode: "+856",
        flag: "https://static.platzi.com/media/flags/LA.png"
    },
    {
        id: 118,
        code: "LV",
        name: "Latvia",
        phoneCode: "+371",
        flag: "https://static.platzi.com/media/flags/LV.png"
    },
    {
        id: 119,
        code: "LB",
        name: "Lebanon",
        phoneCode: "+961",
        flag: "https://static.platzi.com/media/flags/LB.png"
    },
    {
        id: 120,
        code: "LS",
        name: "Lesotho",
        phoneCode: "+266",
        flag: "https://static.platzi.com/media/flags/LS.png"
    },
    {
        id: 121,
        code: "LR",
        name: "Liberia",
        phoneCode: "+231",
        flag: "https://static.platzi.com/media/flags/LR.png"
    },
    {
        id: 122,
        code: "LY",
        name: "Libya",
        phoneCode: "+218",
        flag: "https://static.platzi.com/media/flags/LY.png"
    },
    {
        id: 123,
        code: "LI",
        name: "Liechtenstein",
        phoneCode: "+423",
        flag: "https://static.platzi.com/media/flags/LI.png"
    },
    {
        id: 124,
        code: "LT",
        name: "Lithuania",
        phoneCode: "+370",
        flag: "https://static.platzi.com/media/flags/LT.png"
    },
    {
        id: 126,
        code: "MO",
        name: "Macao",
        phoneCode: "+853",
        flag: "https://static.platzi.com/media/flags/MO.png"
    },
    {
        id: 127,
        code: "MK",
        name: "Macedonia",
        phoneCode: "+389",
        flag: "https://static.platzi.com/media/flags/MK.png"
    },
    {
        id: 128,
        code: "MG",
        name: "Madagascar",
        phoneCode: "+261",
        flag: "https://static.platzi.com/media/flags/MG.png"
    },
    {
        id: 129,
        code: "MW",
        name: "Malawi",
        phoneCode: "+265",
        flag: "https://static.platzi.com/media/flags/MW.png"
    },
    {
        id: 130,
        code: "MY",
        name: "Malaysia",
        phoneCode: "+60",
        flag: "https://static.platzi.com/media/flags/MY.png"
    },
    {
        id: 131,
        code: "MV",
        name: "Maldives",
        phoneCode: "+960",
        flag: "https://static.platzi.com/media/flags/MV.png"
    },
    {
        id: 132,
        code: "ML",
        name: "Mali",
        phoneCode: "+223",
        flag: "https://static.platzi.com/media/flags/ML.png"
    },
    {
        id: 133,
        code: "MT",
        name: "Malta",
        phoneCode: "+356",
        flag: "https://static.platzi.com/media/flags/MT.png"
    },
    {
        id: 134,
        code: "MH",
        name: "Marshall Islands",
        phoneCode: "+692",
        flag: "https://static.platzi.com/media/flags/MH.png"
    },
    {
        id: 135,
        code: "MQ",
        name: "Martinique",
        phoneCode: "+596",
        flag: "https://static.platzi.com/media/flags/MQ.png"
    },
    {
        id: 136,
        code: "MR",
        name: "Mauritania",
        phoneCode: "+222",
        flag: "https://static.platzi.com/media/flags/MR.png"
    },
    {
        id: 138,
        code: "YT",
        name: "Mayotte",
        phoneCode: "+262",
        flag: "https://static.platzi.com/media/flags/YT.png"
    },
    {
        id: 139,
        code: "FM",
        name: "Micronesia",
        phoneCode: "+691",
        flag: "https://static.platzi.com/media/flags/FM.png"
    },
    {
        id: 140,
        code: "MD",
        name: "Moldova",
        phoneCode: "+373",
        flag: "https://static.platzi.com/media/flags/MD.png"
    },
    {
        id: 141,
        code: "MC",
        name: "Monaco",
        phoneCode: "+377",
        flag: "https://static.platzi.com/media/flags/MC.png"
    },
    {
        id: 142,
        code: "MN",
        name: "Mongolia",
        phoneCode: "+976",
        flag: "https://static.platzi.com/media/flags/MN.png"
    },
    {
        id: 143,
        code: "ME",
        name: "Montenegro",
        phoneCode: "+382",
        flag: "https://static.platzi.com/media/flags/ME.png"
    },
    {
        id: 144,
        code: "MS",
        name: "Montserrat",
        phoneCode: "+1-664",
        flag: "https://static.platzi.com/media/flags/MS.png"
    },
    {
        id: 145,
        code: "MA",
        name: "Morocco",
        phoneCode: "+212",
        flag: "https://static.platzi.com/media/flags/MA.png"
    },
    {
        id: 146,
        code: "MZ",
        name: "Mozambique",
        phoneCode: "+258",
        flag: "https://static.platzi.com/media/flags/MZ.png"
    },
    {
        id: 147,
        code: "MM",
        name: "Myanmar",
        phoneCode: "+95",
        flag: "https://static.platzi.com/media/flags/MM.png"
    },
    {
        id: 148,
        code: "NA",
        name: "Namibia",
        phoneCode: "+264",
        flag: "https://static.platzi.com/media/flags/NA.png"
    },
    {
        id: 149,
        code: "NR",
        name: "Naur",
        phoneCode: "+674",
        flag: "https://static.platzi.com/media/flags/NR.png"
    },
    {
        id: 150,
        code: "NP",
        name: "Nepal",
        phoneCode: "+977",
        flag: "https://static.platzi.com/media/flags/NP.png"
    },
    {
        id: 55,
        code: "CU",
        name: "Cuba",
        phoneCode: "+53",
        flag: "https://static.platzi.com/media/flags/C.png"
    },
    {
        id: 152,
        code: "NC",
        name: "New Caledonia",
        phoneCode: "+687",
        flag: "https://static.platzi.com/media/flags/NC.png"
    },
    {
        id: 153,
        code: "NZ",
        name: "New Zealand",
        phoneCode: "+64",
        flag: "https://static.platzi.com/media/flags/NZ.png"
    },
    {
        id: 154,
        code: "NI",
        name: "Nicaragua",
        phoneCode: "+505",
        flag: "https://static.platzi.com/media/flags/NI.png"
    },
    {
        id: 155,
        code: "NE",
        name: "Niger",
        phoneCode: "+227",
        flag: "https://static.platzi.com/media/flags/NE.png"
    },
    {
        id: 156,
        code: "NG",
        name: "Nigeria",
        phoneCode: "+234",
        flag: "https://static.platzi.com/media/flags/NG.png"
    },
    {
        id: 158,
        code: "NF",
        name: "Norfolk Island",
        phoneCode: "+672",
        flag: "https://static.platzi.com/media/flags/NF.png"
    },
    {
        id: 159,
        code: "KP",
        name: "North Korea",
        phoneCode: "+850",
        flag: "https://static.platzi.com/media/flags/KP.png"
    },
    {
        id: 160,
        code: "MP",
        name: "Northern Mariana Islands",
        phoneCode: "+1-670",
        flag: "https://static.platzi.com/media/flags/MP.png"
    },
    {
        id: 161,
        code: "NO",
        name: "Norway",
        phoneCode: "+47",
        flag: "https://static.platzi.com/media/flags/NO.png"
    },
    {
        id: 162,
        code: "OM",
        name: "Oman",
        phoneCode: "+968",
        flag: "https://static.platzi.com/media/flags/OM.png"
    },
    {
        id: 163,
        code: "PK",
        name: "Pakistan",
        phoneCode: "+92",
        flag: "https://static.platzi.com/media/flags/PK.png"
    },
    {
        id: 164,
        code: "PW",
        name: "Pala",
        phoneCode: "+680",
        flag: "https://static.platzi.com/media/flags/PW.png"
    },
    {
        id: 165,
        code: "PS",
        name: "Palestinian Territory",
        phoneCode: "+970",
        flag: "https://static.platzi.com/media/flags/PS.png"
    },
    {
        id: 166,
        code: "PA",
        name: "Panama",
        phoneCode: "+507",
        flag: "https://static.platzi.com/media/flags/PA.png"
    },
    {
        id: 167,
        code: "PG",
        name: "Papua New Guinea",
        phoneCode: "+675",
        flag: "https://static.platzi.com/media/flags/PG.png"
    },
    {
        id: 168,
        code: "PY",
        name: "Paraguay",
        phoneCode: "+595",
        flag: "https://static.platzi.com/media/flags/PY.png"
    },
    {
        id: 169,
        code: "PH",
        name: "Philippines",
        phoneCode: "+63",
        flag: "https://static.platzi.com/media/flags/PH.png"
    },
    {
        id: 170,
        code: "PN",
        name: "Pitcairn",
        phoneCode: "+870",
        flag: "https://static.platzi.com/media/flags/PN.png"
    },
    {
        id: 171,
        code: "PL",
        name: "Poland",
        phoneCode: "+48",
        flag: "https://static.platzi.com/media/flags/PL.png"
    },
    {
        id: 88,
        code: "GU",
        name: "Guam",
        phoneCode: "+1-671",
        flag: "https://static.platzi.com/media/flags/G.png"
    },
    {
        id: 173,
        code: "PR",
        name: "Puerto Rico",
        phoneCode: "+1-787",
        flag: "https://static.platzi.com/media/flags/PR.png"
    },
    {
        id: 174,
        code: "PR1",
        name: "Puerto Rico",
        phoneCode: "+1-939",
        flag: "https://static.platzi.com/media/flags/PR1.png"
    },
    {
        id: 175,
        code: "QA",
        name: "Qatar",
        phoneCode: "+974",
        flag: "https://static.platzi.com/media/flags/QA.png"
    },
    {
        id: 176,
        code: "CG",
        name: "Republic of the Congo",
        phoneCode: "+242",
        flag: "https://static.platzi.com/media/flags/CG.png"
    },
    {
        id: 177,
        code: "RO",
        name: "Romania",
        phoneCode: "+40",
        flag: "https://static.platzi.com/media/flags/RO.png"
    },
    {
        id: 179,
        code: "RW",
        name: "Rwanda",
        phoneCode: "+250",
        flag: "https://static.platzi.com/media/flags/RW.png"
    },
    {
        id: 180,
        code: "BL",
        name: "Saint Barthelemy",
        phoneCode: "+590",
        flag: "https://static.platzi.com/media/flags/BL.png"
    },
    {
        id: 181,
        code: "SH",
        name: "Saint Helena",
        phoneCode: "+290",
        flag: "https://static.platzi.com/media/flags/SH.png"
    },
    {
        id: 182,
        code: "KN",
        name: "Saint Kitts and Nevis",
        phoneCode: "+1-869",
        flag: "https://static.platzi.com/media/flags/KN.png"
    },
    {
        id: 183,
        code: "LC",
        name: "Saint Lucia",
        phoneCode: "++1-758",
        flag: "https://static.platzi.com/media/flags/LC.png"
    },
    {
        id: 184,
        code: "MF",
        name: "Saint Martin",
        phoneCode: "+590",
        flag: "https://static.platzi.com/media/flags/MF.png"
    },
    {
        id: 185,
        code: "PM",
        name: "Saint Pierre and Miquelon",
        phoneCode: "+508",
        flag: "https://static.platzi.com/media/flags/PM.png"
    },
    {
        id: 186,
        code: "VC",
        name: "Saint Vincent and the Grenadines",
        phoneCode: "+1-784",
        flag: "https://static.platzi.com/media/flags/VC.png"
    },
    {
        id: 187,
        code: "WS",
        name: "Samoa",
        phoneCode: "+685",
        flag: "https://static.platzi.com/media/flags/WS.png"
    },
    {
        id: 188,
        code: "SM",
        name: "San Marino",
        phoneCode: "+378",
        flag: "https://static.platzi.com/media/flags/SM.png"
    },
    {
        id: 189,
        code: "ST",
        name: "Sao Tome and Principe",
        phoneCode: "+239",
        flag: "https://static.platzi.com/media/flags/ST.png"
    },
    {
        id: 191,
        code: "SN",
        name: "Senegal",
        phoneCode: "+221",
        flag: "https://static.platzi.com/media/flags/SN.png"
    },
    {
        id: 192,
        code: "RS",
        name: "Serbia",
        phoneCode: "+381",
        flag: "https://static.platzi.com/media/flags/RS.png"
    },
    {
        id: 193,
        code: "SC",
        name: "Seychelles",
        phoneCode: "+248",
        flag: "https://static.platzi.com/media/flags/SC.png"
    },
    {
        id: 194,
        code: "SL",
        name: "Sierra Leone",
        phoneCode: "+232",
        flag: "https://static.platzi.com/media/flags/SL.png"
    },
    {
        id: 195,
        code: "SG",
        name: "Singapore",
        phoneCode: "+65",
        flag: "https://static.platzi.com/media/flags/SG.png"
    },
    {
        id: 196,
        code: "SX",
        name: "Sint Maarten",
        phoneCode: "+599",
        flag: "https://static.platzi.com/media/flags/SX.png"
    },
    {
        id: 197,
        code: "SK",
        name: "Slovakia",
        phoneCode: "+421",
        flag: "https://static.platzi.com/media/flags/SK.png"
    },
    {
        id: 198,
        code: "SI",
        name: "Slovenia",
        phoneCode: "+386",
        flag: "https://static.platzi.com/media/flags/SI.png"
    },
    {
        id: 199,
        code: "SB",
        name: "Solomon Islands",
        phoneCode: "+677",
        flag: "https://static.platzi.com/media/flags/SB.png"
    },
    {
        id: 200,
        code: "SO",
        name: "Somalia",
        phoneCode: "+252",
        flag: "https://static.platzi.com/media/flags/SO.png"
    },
    {
        id: 201,
        code: "ZA",
        name: "South Africa",
        phoneCode: "+27",
        flag: "https://static.platzi.com/media/flags/ZA.png"
    },
    {
        id: 202,
        code: "KR",
        name: "South Korea",
        phoneCode: "+82",
        flag: "https://static.platzi.com/media/flags/KR.png"
    },
    {
        id: 204,
        code: "LK",
        name: "Sri Lanka",
        phoneCode: "+94",
        flag: "https://static.platzi.com/media/flags/LK.png"
    },
    {
        id: 205,
        code: "SD",
        name: "Sudan",
        phoneCode: "+249",
        flag: "https://static.platzi.com/media/flags/SD.png"
    },
    {
        id: 206,
        code: "SR",
        name: "Suriname",
        phoneCode: "+597",
        flag: "https://static.platzi.com/media/flags/SR.png"
    },
    {
        id: 207,
        code: "SJ",
        name: "Svalbard and Jan Mayen",
        phoneCode: "+47",
        flag: "https://static.platzi.com/media/flags/SJ.png"
    },
    {
        id: 208,
        code: "SZ",
        name: "Swaziland",
        phoneCode: "+268",
        flag: "https://static.platzi.com/media/flags/SZ.png"
    },
    {
        id: 209,
        code: "SE",
        name: "Sweden",
        phoneCode: "+46",
        flag: "https://static.platzi.com/media/flags/SE.png"
    },
    {
        id: 210,
        code: "CH",
        name: "Switzerland",
        phoneCode: "+41",
        flag: "https://static.platzi.com/media/flags/CH.png"
    },
    {
        id: 211,
        code: "SY",
        name: "Syria",
        phoneCode: "+963",
        flag: "https://static.platzi.com/media/flags/SY.png"
    },
    {
        id: 212,
        code: "TW",
        name: "Taiwan",
        phoneCode: "+886",
        flag: "https://static.platzi.com/media/flags/TW.png"
    },
    {
        id: 213,
        code: "TJ",
        name: "Tajikistan",
        phoneCode: "+992",
        flag: "https://static.platzi.com/media/flags/TJ.png"
    },
    {
        id: 190,
        code: "SA",
        name: "Emiratos Arabes Unidos",
        phoneCode: "+971",
        flag: "https://static.platzi.com/media/flags/sa.jpg"
    },
    {
        id: 214,
        code: "TZ",
        name: "Tanzania",
        phoneCode: "+255",
        flag: "https://static.platzi.com/media/flags/TZ.png"
    },
    {
        id: 215,
        code: "TH",
        name: "Thailand",
        phoneCode: "+66",
        flag: "https://static.platzi.com/media/flags/TH.png"
    },
    {
        id: 216,
        code: "TG",
        name: "Togo",
        phoneCode: "+228",
        flag: "https://static.platzi.com/media/flags/TG.png"
    },
    {
        id: 217,
        code: "TK",
        name: "Tokela",
        phoneCode: "+690",
        flag: "https://static.platzi.com/media/flags/TK.png"
    },
    {
        id: 218,
        code: "TO",
        name: "Tonga",
        phoneCode: "+676",
        flag: "https://static.platzi.com/media/flags/TO.png"
    },
    {
        id: 219,
        code: "TT",
        name: "Trinidad and Tobago",
        phoneCode: "++1-868",
        flag: "https://static.platzi.com/media/flags/TT.png"
    },
    {
        id: 220,
        code: "TN",
        name: "Tunisia",
        phoneCode: "+216",
        flag: "https://static.platzi.com/media/flags/TN.png"
    },
    {
        id: 221,
        code: "TR",
        name: "Turkey",
        phoneCode: "+90",
        flag: "https://static.platzi.com/media/flags/TR.png"
    },
    {
        id: 222,
        code: "TM",
        name: "Turkmenistan",
        phoneCode: "+993",
        flag: "https://static.platzi.com/media/flags/TM.png"
    },
    {
        id: 223,
        code: "TC",
        name: "Turks and Caicos Islands",
        phoneCode: "+1-649",
        flag: "https://static.platzi.com/media/flags/TC.png"
    },
    {
        id: 224,
        code: "TV",
        name: "Tuval",
        phoneCode: "+688",
        flag: "https://static.platzi.com/media/flags/TV.png"
    },
    {
        id: 225,
        code: "VI",
        name: "U.S. Virgin Islands",
        phoneCode: "+1-340",
        flag: "https://static.platzi.com/media/flags/VI.png"
    },
    {
        id: 226,
        code: "UG",
        name: "Uganda",
        phoneCode: "+256",
        flag: "https://static.platzi.com/media/flags/UG.png"
    },
    {
        id: 227,
        code: "UA",
        name: "Ukraine",
        phoneCode: "+380",
        flag: "https://static.platzi.com/media/flags/UA.png"
    },
    {
        id: 228,
        code: "AE",
        name: "United Arab Emirates",
        phoneCode: "+971",
        flag: "https://static.platzi.com/media/flags/AE.png"
    },
    {
        id: 97,
        code: "HU",
        name: "Hungary",
        phoneCode: "+36",
        flag: "https://static.platzi.com/media/flags/H.png"
    },
    {
        id: 230,
        code: "UY",
        name: "Uruguay",
        phoneCode: "+598",
        flag: "https://static.platzi.com/media/flags/UY.png"
    },
    {
        id: 231,
        code: "UZ",
        name: "Uzbekistan",
        phoneCode: "+998",
        flag: "https://static.platzi.com/media/flags/UZ.png"
    },
    {
        id: 233,
        code: "VA",
        name: "Vatican",
        phoneCode: "+379",
        flag: "https://static.platzi.com/media/flags/VA.png"
    },
    {
        id: 234,
        code: "VE",
        name: "Venezuela",
        phoneCode: "+58",
        flag: "https://static.platzi.com/media/flags/VE.png"
    },
    {
        id: 235,
        code: "VN",
        name: "Vietnam",
        phoneCode: "+84",
        flag: "https://static.platzi.com/media/flags/VN.png"
    },
    {
        id: 236,
        code: "WF",
        name: "Wallis and Futuna",
        phoneCode: "+681",
        flag: "https://static.platzi.com/media/flags/WF.png"
    },
    {
        id: 237,
        code: "EH",
        name: "Western Sahara",
        phoneCode: "+212",
        flag: "https://static.platzi.com/media/flags/EH.png"
    },
    {
        id: 238,
        code: "YE",
        name: "Yemen",
        phoneCode: "+967",
        flag: "https://static.platzi.com/media/flags/YE.png"
    },
    {
        id: 239,
        code: "ZM",
        name: "Zambia",
        phoneCode: "+260",
        flag: "https://static.platzi.com/media/flags/ZM.png"
    },
    {
        id: 240,
        code: "ZW",
        name: "Zimbabwe",
        phoneCode: "+263",
        flag: "https://static.platzi.com/media/flags/ZW.png"
    },
    {
        id: 241,
        code: "CW",
        name: "Curazao",
        phoneCode: "+5999",
        flag: "https://static.platzi.com/media/flags/CW.png"
    },
    {
        id: 62,
        code: "DO",
        name: "Dominican Republic",
        phoneCode: "+1809",
        flag: "https://static.platzi.com/media/flags/DO.png"
    },
    {
        id: 64,
        code: "DO2",
        name: "Dominican Republic",
        phoneCode: "+1829",
        flag: "https://static.platzi.com/media/flags/DO2.png"
    },
    {
        id: 63,
        code: "DO1",
        name: "Dominican Republic",
        phoneCode: "+1849",
        flag: "https://static.platzi.com/media/flags/DO1.png"
    },
    {
        id: 203,
        code: "ES",
        name: "Espana",
        phoneCode: "+34",
        flag: "https://static.platzi.com/media/flags/ES.png"
    },
    {
        id: 82,
        code: "DE",
        name: "Germany",
        phoneCode: "+49",
        flag: "https://static.platzi.com/media/flags/DE.png"
    },
    {
        id: 229,
        code: "GB",
        name: "United Kingdom",
        phoneCode: "+44",
        flag: "https://static.platzi.com/media/flags/GB.png"
    },
    {
        id: 172,
        code: "PT",
        name: "Portugal",
        phoneCode: "+351",
        flag: "https://static.platzi.com/media/flags/PT.png"
    },
    {
        id: 151,
        code: "NL",
        name: "Netherlands",
        phoneCode: "+31",
        flag: "https://static.platzi.com/media/flags/NL.png"
    },
    {
        id: 125,
        code: "LU",
        name: "Luxembourg",
        phoneCode: "+352",
        flag: "https://static.platzi.com/media/flags/L.png"
    }
]